module.exports = __webpack_public_path__ + "img/icon_01.f664e147.png";